module.exports = __webpack_public_path__ + "media/images/post/ico-mail-5246099bef48938c7187d052684fc124.svg";